import styled from "styled-components";

const Fieldset = styled.fieldset`
  margin: 1em 0;
  padding: 1em 0;
`;

export default Fieldset;
